import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import APP_API_ROUTE from "../../config/apiRoute";

const portalApi = createApi({
  reducerPath: "portalApi",
  baseQuery: fetchBaseQuery({ baseUrl: APP_API_ROUTE }),
  endpoints: (builder) => ({}),
});

export default portalApi;
